<template>
  <div>
    <b-sidebar
      :id="sidebarId"
      centered
      :width="width"
      ref="qrEditor"
      right
      :backdrop-variant="variant"
      backdrop
      shadow
      no-header
      @change="handleSidebarChange"
    >
      <b-container>
        <b-row style="margin-top: 50px;">
          <b-col cols="6">
            <b-img-lazy
              v-if="imgURL"
              :src="imgURL"
              :alt="`${title} cover`"
              style="height: 600px; object-fit: cover; float: left"
            />
          </b-col>
          <b-col cols="6">
            <h5>{{ title }}</h5>
            <p>{{ slug }}</p>
            <b-form-group label="Distributor:">
              <b-form-input
                type="text"
                required
                v-model="distribution"
                placeholder="Where are you uploading your digital manuscript?"
              ></b-form-input>
            </b-form-group>
            <b-form-group label="Delivery Channel:">
              <b-form-input
                type="text"
                required
                v-model="formatType"
                placeholder="Paperback of Hardcover"
              ></b-form-input>
            </b-form-group>
            <b-form-group label="Book Format:" v-slot="{ ariaDescribedby }">
              <b-form-radio-group
                id="btn-radios-2"
                v-model="selectedFormat"
                :options="formatOptions"
                :aria-describedby="ariaDescribedby"
                button-variant="outline-primary"
                size="lg"
                name="radio-btn-outline"
                buttons
              />
            </b-form-group>
            <b-form-group
              label="Where shall we place your D3rriana?"
              v-slot="{ ariaDescribedby }"
            >
              <b-form-radio-group
                id="btn-radios-2"
                v-model="selectedPlacement"
                :options="placementOptions"
                :aria-describedby="ariaDescribedby"
                button-variant="outline-primary"
                size="lg"
                name="radio-btn-outline"
                buttons
              />
            </b-form-group>
            <b-form-group label="Select QR Style" v-slot="{ ariaDescribedby }">
              <b-form-radio-group
                id="btn-radios-2"
                v-model="selectedStyle"
                :options="styleOptions"
                :aria-describedby="ariaDescribedby"
                button-variant="outline-primary"
                size="lg"
                name="radio-btn-outline"
                buttons
              />
            </b-form-group>
            <b-button
              class="btn-primary btn-round-fill"
              @click="handleGenerateLogo"
            >
              Generate
            </b-button>
            <b-button
              class="btn-primary btn-round-fill"
              @click="handleConvertImgURL"
            >
              Prep Book
            </b-button>
            <b-button
              class="btn-primary btn-round-fill"
              @click="handleGenerateBook"
            >
              Generate Placement
            </b-button>
            <div v-if="qrWithCornerLogo">
              <img :src="qrWithCornerLogo" />
              <b-link @click="handleRemoveGen">Remove</b-link> |
              <a download="qrCode.png" :href="qrWithCornerLogo">Download</a>
              <b-link v-if="false" @click="handleDownloadGen">Download</b-link>
            </div>
            <div v-if="false">
              <vue-qr
                :bgSrc="imgURL"
                :logoSrc="src2"
                text="Hello world!"
                :size="200"
              ></vue-qr>
              <vue-qr text="Hello world!"></vue-qr>
              <vue-qr
                :bgSrc="src"
                :logoSrc="src2"
                text="Hello world!"
                :size="200"
              ></vue-qr>
              <vue-qr
                text="Hello world!"
                :callback="test"
                qid="testid"
              ></vue-qr>
            </div>
          </b-col>
        </b-row>
        <b-row>
          <b-col>
            <img v-if="qrSmile" :src="qrSmile" />
          </b-col>
        </b-row>
      </b-container>
      <template #footer="{ hide }">
        <div class="d-flex bg-dark text-light align-items-center px-3 py-2">
          <div class="mr-auto">
            Patent Pending
          </div>
          <b-button size="sm" @click="hide">Close</b-button>
        </div>
      </template>
    </b-sidebar>
  </div>
</template>

<script>
import qr from "qr-image";
import VueQr from "vue-qr";
import mergeImages from "merge-images";
import { mapGetters } from "vuex";
import axios from "axios";
export default {
  name: "ToolQRGenerator",
  components: {
    VueQr
  },
  props: {
    sidebarId: {
      type: String,
      default: null
    },
    publishingId: {
      type: String,
      default: null
    }
  },
  computed: {
    ...mapGetters({
      user: "user/user",
      publishings: "user/listPublishings",
      getLocalPublishingWithId: "user/getLocalPublishingWithId"
    }),
    publishing() {
      // return this.localPublishingWithId(this.publishingId);
      return this.publishings && Array.isArray(this.publishings)
        ? this.publishings.filter(aPublishing => {
            return aPublishing.id === this.publishingId;
          })[0]
        : null;
    },
    title() {
      return this.publishing ? this.publishing.title : null;
    },
    slug() {
      //TODOAttempt to make temp or pull from existing
      //Users may be able to register name
      return this.title ? this.title.toLowerCase().replaceAll(" ", "-") : null;
    },
    cornerURL() {
      return `https://d3rriana.com/corner/${this.slug}`;
    },
    qrBasePNG() {
      switch (this.selectedStyle) {
        case "A":
          return "/qr/cornerQRBaseA.png";
        case "B":
          return "/qr/cornerQRBaseB.png";
        case "C":
          return "/qr/cornerQRBaseBlank.png";
        default:
          return "/qr/cornerQRBaseA.png";
      }
    },
    qrCornerFinalURL() {
      return this.cornerURL;
    },
    qrCornerFinalSVG() {
      return this.qrCornerFinalURL
        ? qr.imageSync(this.cornerURL, {
            type: "svg",
            size: this.qrSize,
            margin: this.qrMargin
          })
        : "placeholder";
    },
    qrCornerFinalB64SVG() {
      return "data:image/svg+xml;base64," + window.btoa(this.qrCornerFinalSVG);
      // var url = 'url("' + b64 + '")';
    },
    imgURL() {
      if (this.publishing) {
        //this.convertImgURL();
        return this.publishing.imgURL;
      }
      return null;
    },
    width() {
      return this.mini ? "20%" : "80%";
    }
  },
  data() {
    return {
      selectedStyle: "A",
      selectedFormat: "paperback",
      selectedPlacement: "front",
      styleOptions: [
        { text: "Standard", value: "A" },
        { text: "Blank", value: "B" },
        { text: "QR Only", value: "C" },
        { text: "Custom", value: "C", disabled: true }
      ],
      formatOptions: [
        { text: "Paperback", value: "paperback" },
        { text: "Hardcover", value: "hardcover" },
        { text: "Electronic", value: "electronic" }
      ],
      placementOptions: [
        { text: "Front (Cover)", value: "front" },
        { text: "Back (Cover)", value: "back" },
        { text: "Inside", value: "inside", disabled: true },
        { text: "Banner", value: "band" }
      ],
      qrSize: 6,
      qrMargin: 11,
      qrWithCornerLogo: null,
      src: "/qr/cornerQRBaseA.png",
      src2: "/qr/cornerQRBase.png",
      qrGen: null,
      imgURLBase64: null,
      distribution: null,
      formatType: null,
      placement: null,
      deliveryChannel: null,
      variant: "dark",
      fullscreenCard: null,
      mini: false,
      qrSVG: null,
      qrSVGDownload: null,
      qrSmile: null,
      qrSample:
        "data:image/png;base64,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"
    };
  },
  methods: {
    test(dataUrl, id) {
      console.log(`URL :${dataUrl} and ID: ${id}`);
    },
    localPublishingWithId(pubId) {
      return this.getLocalPublishingWithId(pubId);
    },
    handleGenerateSmile() {
      mergeImages([
        "/qr/body.png",
        "/qr/eyes.png",
        "/qr/mouth.png",
        this.qrCornerFinalB64SVG
      ]).then(b64 => (this.qrSmile = b64));
    },
    handleGenerateLogo() {
      mergeImages([this.qrBasePNG, this.qrCornerFinalB64SVG]).then(
        b64 => (this.qrWithCornerLogo = b64)
      );
    },
    handleGenerateBook() {
      mergeImages([this.imgURL, this.qrBasePNG]).then(
        b64 => (this.qrSmile = b64)
      );
    },
    handleRefreshPublishing() {
      console.log("updating publishings-toolCornerEditorr");
      this.$emit("refresh-publishings");
    },
    handleSidebarChange() {
      //TODO can be improved to update on either close or open and not both
      console.log(`The publishing Id is ${this.publishingId}`);
      this.isLocalPublishingCorner = true;
      this.qrWithCornerLogo = null;
    },
    handleConvertImgURL() {
      const img = this.imgURL;
      const canvas = document.createElement("canvas");
      canvas.width = img.width;
      canvas.height = img.height;
      const ctx = canvas.getContext("2d");
      ctx.drawImage(img, 0, 0);
      const dataURL = canvas.toDataURL("image/png");
      this.imgURLBase64 = dataURL.replace(/^data:image\/(png|jpg);base64,/, "");
    },
    convertURLToBase64(imgURL) {
      /* const getBase64Img = async () => {
        const image = await axios.get(imgURL, { responseType: "arraybuffer" })
        this.imgURLBase64= 'data:image/jpeg;base64,' + Buffer.from(image.data).toString('base64')
      }
      */
    },
    handleRemoveGen() {
      this.qrWithCornerLogo = null;
    },
    handleDownloadGen() {}
  },
  filters: {},
  mounted() {}
};
</script>

<style lang="scss" scoped>
.add-crew {
  height: 100vh;
}
.ico__edit {
  cursor: pointer;
}
.bg-white {
  border-top-right-radius: 20px;
  border-bottom-right-radius: 20px;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
}

@media (max-width: 1200px) {
  .bg-white {
    border-top-right-radius: 0 !important;
    border-bottom-right-radius: 20px;
    border-bottom-left-radius: 20px;
  }
}
.bg-grey {
  background: #f3f6f9;
}
.p3040 {
  padding: 30px 40px;
  border-radius: 20px 0 0 20px;
}
.p24 {
  padding: 24px;
  border-radius: 20px;
  background-color: #fff;
}
.header-title {
  display: grid;
  grid-template-columns: 1fr 40px;
  .title {
    font-style: normal;
    font-weight: 600;
    font-size: 24px;
    line-height: 33px;
    color: #474d52;
    span {
      font-weight: normal !important;
      color: #8d99a0;
    }
  }
}
.btns-toogle {
  display: flex;
  justify-content: space-between;
  align-items: center;
  flex-wrap: wrap;
  .spot-splash {
    display: flex;
    justify-content: center;
    align-items: center;
    span {
      font-style: normal;
      font-weight: bold;
      font-size: 14px;
      line-height: 19px;
      color: #b3c2cb;
      &.active {
        color: #557efb;
      }
    }
    .switch {
      margin: 0 8px;
      position: relative;
      display: inline-block;
      width: 62px;
      height: 32px;
    }

    .switch input {
      opacity: 0;
      width: 0;
      height: 0;
    }

    .slider {
      position: absolute;
      cursor: pointer;
      top: 0;
      left: 0;
      right: 0;
      bottom: 0;
      background-color: #fff;
      -webkit-transition: 0.4s;
      transition: 0.4s;
    }

    .slider:before {
      position: absolute;
      content: "";
      height: 24px;
      width: 24px;
      left: 4px;
      bottom: 4px;
      background-color: #557efb;
      -webkit-transition: 0.4s;
      transition: 0.4s;
    }

    input:checked + .slider {
      background-color: #fff;
    }

    input:focus + .slider {
      // box-shadow: 0 0 1px #2196F3;
    }

    input:checked + .slider:before {
      -webkit-transform: translateX(26px);
      -ms-transform: translateX(26px);
      transform: translateX(26px);
    }

    /* Rounded sliders */
    .slider.round {
      border-radius: 34px;
    }

    .slider.round:before {
      border-radius: 50%;
    }
  }
}
.card-grid {
  display: grid;
  grid-template-columns: 1fr 1fr 1fr;
  grid-gap: 16px 25px;
  margin-top: 25px;
  @media (max-width: 1200px) {
    grid-template-columns: 1fr 1fr;
  }
  @media (max-width: 560px) {
    grid-template-columns: 1fr;
  }
  &.fullscreen {
    grid-template-columns: 1fr 250px;
    grid-gap: 0;
    @media (min-width: 1200px) {
      grid-template-columns: 1fr 350px;
    }
  }
}
.labels-radial {
  display: grid;
  grid-template-columns: 1fr 1fr 1fr;
  .label-graph {
    display: flex;
    justify-content: flex-start;
    align-items: center;
    .color-label {
      width: 16px;
      height: 16px;
      // background: #52b6d6;
      border-radius: 5px;
      margin: 4px;
    }
  }
}

.overlay {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background: transparent;
  z-index: 2;
}
@media (min-width: 991px) {
  .sidebar-dashcard {
    min-height: 100vh;
  }
}
@media (max-width: 1200px) {
  .p3040 {
    border-radius: 20px 20px 0 0;
  }
  .p24 {
    border-top-left-radius: 0;
    border-top-right-radius: 0;
  }
}
@media (max-width: 568px) {
  .btns-toogle {
    // flex-direction: column;
    // align-items: flex-start;
    justify-content: space-around;
  }
}
@media (max-width: 450px) {
  .btns-toogle {
    height: 160px;
    flex-direction: column;
    align-items: center;
    justify-content: space-around;
  }
}
.nav__baseline {
  position: absolute;
  bottom: 16px;
  left: 50%;
  transform: translateX(-50%);
}
.editor {
  background: #fff;
  height: 100%;
  border-radius: 0 20px 20px 0;
  box-shadow: 6px 6px 20px rgb(20 36 74 / 5%);
}
.foot-text {
  margin: 20px 14px;
  p {
    font-style: normal;
    font-weight: normal;
    font-size: 12px;
    line-height: 16px;
    color: #8d99a0;
    margin: 0;
  }
}
</style>
